import apiUrl from "../../../constants";
import axios from "axios";
import CryptoJS from "crypto-js";
import { Validator } from "vee-validate";
import VueElementLoading from "vue-element-loading";
import Paginate from "vuejs-paginate";
import { BasicSelect } from 'vue-search-select';
import moment from 'moment';
import PageTracker from '../../../common/PageTrackerHelper'
import keycloak from '../../../common/Keycloak';

export default {
  name: "RTODeliveryStatus",
  components: {
    VueElementLoading,
    Paginate,
    BasicSelect
  },
  mixins:[PageTracker],
  data: function() {
    return {
      checkCount: null,
      hubname: "",
      receiverName: "",
      time: "",
      shipmenttype: "",
      dateobj: {
        toDate: "",
        ReattemptDate:""
      },
      statusCode: "",
      hubServiceCenterList: [],
      localusermailid: "",
      localuserid: "",
      rolename: "",
      max: 500,
      errormsg: [],
      checkValue: 0,
      Loading: false,
      file: "",
      scanFlag: false,
      validated: true,
      styleObject: {
        "margin-bottom": "15px",
        "background-color": "#fff"
      },
      getShipmentList: [],
      getDeliveryUname: [],
      deliverUserName: "",
      selectedItems: [],
      LatmileShipmentData: [],
      ReasonStatusArr: [],
      updateShipmentData: [],
      LastStoreddata: [],
      CheckIDS: [],
      TestIDS: [],
      pageno: 0,
      pagecount: 0,
      shipmentviewdataflag: false,
      successArr: [],
      failedArr: [],
      viewShipmentData: [],
      isLoading: false,
      LoaderForPopup: false,
      selectedItemdata: false,
      storeShippingid: null,
      disputevalidator:null,
      disputeCode:"",
      DisputeStatusArr:[],
      whdisputeCodevalue :null,
      whdisputeCode:"",
      reasontypedata:[],
      reasonstatus:"",
      dtocountshow:null,
      uniquecodeValue:"",
      alltaskDetails:[],
      setStatus:"",
      awb:'',
      awbArray:[],
      ProcessShipment:[],
      totalCountpagi:0,
      tblErrorshowflag:null,
      deliveryList:[],
      deliveryObj:{ value: "",text: ""},
      srLoader :'',
      loader:'<div class="velmld-spinner"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="20px" height="18px" viewBox="0 0 24 30" xml:space="preserve"><rect x="0" y="5.59869" width="4" height="19.8026" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0s" dur="0.6s" repeatCount="indefinite"></animate></rect> <rect x="10" y="9.59869" width="4" height="11.8026" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0.15s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0.15s" dur="0.6s" repeatCount="indefinite"></animate></rect> <rect x="20" y="12.4013" width="4" height="6.19739" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0.3s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0.3s" dur="0.6s" repeatCount="indefinite"></animate></rect></svg></div>',
      disabledcount:null,
      reciverflage:null,
      DeliverySRList: [],
      hubSpecificTripRestricted: [190,1387],
      subDisputeStatusReasonCodes: [],
      subDisputeCodeFlag: false,
      subDisputeCode: "",
      shippingIdForMeta :[],
      setWebHDFlag: null,
      reattemptDeliveryDateShow:false,
      userDataKey : '',
      userRolesFE : [],
      lmwhhandoverallowed : true,
    };
  },
  created: function() {
    this.getHubList();
      //    this.changeDateFormat();
  },
  async mounted() {
    this.userDataKey = window.localStorage.getItem('userUniqueKey');
    let validateUser = await this.validateJwtToken();
    var userdetailEncrypt = window.localStorage.getItem("lmaccessuserdata");
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    console.log("userdetail", userdetail);
    this.localuserid = userdetail.userid;
    this.localusermailid = userdetail.email;
    this.rolename = userdetail.userrole[0]["rolename"];
    this.userRolesFE = userdetail.userroleFE;
    this.hubname = userdetail.hubdetails[0];
    this.localuseroutsourcingid = userdetail.outsourcingid;
    let flags= await this.checkIsWebHandoverEnableforhub();
    this.setWebHDFlag=flags.iswebhandover;
    this.lmwhhandoverallowed=flags.lmwhhandoverallowed;
    if(!this.setWebHDFlag) {
      this.$alertify.error('Web based status updation is disabled, pls use Mobile App for status updation.')
      this.$router.push('/dashboard')
      return false;
    }

    this.getdeliveryusername();
  },
  methods: {
    checkIsWebHandoverEnableforhub(){
      return new Promise((resolve,reject) => {
        try {
          let Hubid = this.hubname
          let payload = {
            "hubids" : [Hubid],
            "islmwhhandoverallowed" : true
          }
          axios({
            method: 'POST',
            url: apiUrl.api_url + 'expose/hubservicecenter/hubarray/get',
            data: payload,
          })
          .then(async result => {
            let handoverflags={};
            if (result.data.data.code==200) { 
              let IsWebHandover = result.data.data.data[0].ConfigSetting.IsWebHandover;
              let lmwhhandoverallowed = result.data.data.data[0].islmwhhandoverallowed ? result.data.data.data[0].islmwhhandoverallowed :false;
              if(IsWebHandover != null && IsWebHandover == "1"){
                 handoverflags.iswebhandover=true;
                 handoverflags.lmwhhandoverallowed=lmwhhandoverallowed;
               resolve(handoverflags);
              }
              else{
                 handoverflags.iswebhandover=false;
                 handoverflags.lmwhhandoverallowed=false;
                resolve(handoverflags);
              }
            }
            else{
                 handoverflags.iswebhandover=false;
                 handoverflags.lmwhhandoverallowed=false;
                resolve(handoverflags);
            }
          })
        }
        catch(e) {
          console.log('something went wrong, please retry again',e);
        }
      })      
    },

    async validateForm(scope) {
      let srObj = await this.DeliverySRList.filter((obj)=> {
        if(obj.userid ==  this.deliverUserName) {
          return obj;
        }
      })
      //console.log('srObj',srObj[0].isTripAllowedForSR);

      if (!this.dateobj.toDate) {
        return this.$alertify.error("Please enter date");
      } else if (!this.time) {
        return this.$alertify.error("Please enter time");
      } else if (!this.statusCode) {
        return this.$alertify.error("Please select status code");
      } else if (!this.receiverName && this.reciverflage == 1) {
        return this.$alertify.error("Please enter receiverName");
      }else if (this.disputevalidator == 1 && !this.disputeCode) {
      return this.$alertify.error("Please select dispute code");
      }else if(this.reattemptDeliveryDateShow==true && !this.dateobj.ReattemptDate){
        return this.$alertify.error("Please select reattempt date");
      }else if (this.whdisputeCodevalue == 1 && !this.whdisputeCode) {
      return this.$alertify.error("Please Select POD Remarks");
      } else if (
        !this.selectedItems.length &&
        this.selectedItems.length !== null
      ) {
        return this.$alertify.error("Please select atleast one shipment");
      } else if (this.selectedItems.length > 75) {
        return this.$alertify.error(
          "Shipment selection not allow more than 75"
        );
      } else {
        let submitFlag = true;
        //let checkhub = this.hubSpecificTripRestricted.find( value => value == this.hubname );

        //if(checkhub != undefined) {
        if (this.rolename.toLowerCase() == "agent" || this.userRolesFE.includes("agent")) {
          submitFlag = true;
        } else {
          if(srObj[0].isTripAllowedForSR == true) {
            let isTripExist = await this.getExistingTripDetails();
              if(isTripExist == false){
                submitFlag =  false;
                return false;
              } else {
                submitFlag = true;
              }
          } else {
            submitFlag = true;
          }
        }
        //}

      if(submitFlag == true) {
         let formatDate = moment(this.dateobj.toDate).format('YYYY-MM-DD');
         let mydate = formatDate+" "+this.time;
         let Checkdate = new Date(mydate);
         if (Checkdate.toString().toLowerCase() == "invalid date"){
             this.dateobj.toDate = "";
             this.time = "";
           return this.$alertify.error("Invalid Date & Time, Please Re-enter Date & Time");
           return false;
         }

          //this.successArr = [];
          this.failedArr = [];
          this.viewShipmentData = [];
          let setData = {};
          this.updateShipmentData = [];
          let shipdata = {};
          this.isLoading = true;
          await this.LastStoreddata.forEach(row => {
            shipdata[row.ShippingID] = row;
          });

          this.selectedItems.forEach(SelectedShipId => {
            let updateObj = {
              IDProofNumber: "",
              ReAttemptDate: "",
              LastModifiedBy: this.localusermailid,
              Latitude: 0,
              IsSecurityCodeWrongAttempt: false,
              IsPODMarkOnAlternetAddress: false,
              PODPath: "",
              EPaymentName: "",
              EPaymentType: "",
              ProcessCode: "",
              UserProcess: "",
              StatusMarkedFrom: "Web",
              IDProof: "",
              ReceiverMobileNo: "",
              DisputeStatusCode: this.disputeCode !=null? this.disputeCode :"",
              SubNDRCode: this.subDisputeCode != null ? this.subDisputeCode : null,
              Longitude: 0,
              Amount: "",
              DeviceID: "",
              IsOpenDelivery: false,
              RelationshipWithConsignee: "",
              DeliveryUserName: "",
              OldDeliveryUserOrUserId: 0,
              RunSheetId: shipdata[SelectedShipId].SRRunSheetId,
              IsCustomerSigned: false,
              DeviceCapturedDate: "",
              submitDistance: 0,
              DisputeComment: this.whdisputeCode !=null ? this.whdisputeCode :"",
              ReAttemptDate: (this.dateobj.ReattemptDate) ? moment(this.dateobj.ReattemptDate).format('DD-MM-YYYY HH:mm:ss') : '',
              isRiskFlag: shipdata[SelectedShipId].isriskflag,
            };
            this.shippingIdForMeta = shipdata[SelectedShipId].ShippingID.toString()
            updateObj.ShippingId = shipdata[SelectedShipId].ShippingID;
            updateObj.Status = shipdata[SelectedShipId].Status;
            updateObj.ShipmentStatus = shipdata[SelectedShipId].ShipmentStatus;
            updateObj.ClientID = shipdata[SelectedShipId].ClientId;
            updateObj.DeliveryUserID = this.deliverUserName;
            updateObj.ReasonCode = this.statusCode;
            // updateObj.ReasonCode = this.disputeCode !=null? this.disputeCode :""
            // if((!['XBU00161','XBU00111'].includes(this.statusCode))) {
            //   updateObj.ReasonCode = this.disputeCode !=null? this.disputeCode :""
            //   updateObj.DisputeStatusCode = this.subDisputeCode !=null? this.subDisputeCode :""
            // }
            updateObj.ReceiverName = this.receiverName;
            updateObj.DeliveryDateTime = mydate;
            updateObj.CurrentHubID = this.hubname;
            updateObj.ShipmentType = this.shipmenttype;

            //console.log("block ---1");
          if(this.alltaskDetails.length && this.alltaskDetails.includes(updateObj.ShippingId)){
            this.updateObj={};
          }else{
            this.updateShipmentData.push(updateObj);
          }
          });

          if (!this.updateShipmentData.length){
            this.isLoading = false;
            return this.$alertify.error("Shipments Already Updated");
          }

          //console.log("block ---2");
          setData.podData = this.updateShipmentData;
          //console.log("----------------------"+JSON.stringify( setData));


          axios
            .post(
              apiUrl.api_url + `expose/common/api/srrunsheet/bulk/pod`,
              setData
            )
            .then(response => {
              this.selectedItems.forEach(checkids => {
                if (response.data.data[checkids]) {
                  if (response.data.data[checkids].code == 200) {
                    try {
                      let TrackerInfo = {
                        projectname: "Last Mile",
                        type: "Web",
                        userid: this.localuserid,
                        username: this.localusermailid,
                        routeurl: "expose/common/api/srrunsheet/bulk/pod",
                        meta: {
                          "event": "common-api-srrunsheet-bulk-pod",
                          shipmentId: this.shippingIdForMeta ? this.shippingIdForMeta : null,
                          remarks: "FrontEnd",
                          hubId: this.hubname ? this.hubname : null
                        }
                      }
                      Object.assign(TrackerInfo.meta, setData);
                      this.PageTracker(TrackerInfo);
                    } catch (error) {
                      console.log(error);
                    }
                    let objpassed = {
                      ShippingID: checkids,
                      message: response.data.data[checkids].message
                    };
                    this.alltaskDetails.push(objpassed.ShippingID);
                    this.successArr.push(objpassed);
                  } else {
                    let getShowData = JSON.stringify(
                      response.data.data[checkids].updateFrameworkData
                    );
                    let objfailed = {
                      ShippingID: checkids,
                      message: response.data.data[checkids].message,
                      updateFrameworkData: getShowData
                    };
                    this.failedArr.push(objfailed);
                  }
                }
              });
              this.isLoading = false;
            })
            .catch(httpException => {
              this.$alertify.error("User details not found");
              console.error("exception is:::::::::", httpException);
            });
          }
      }
    },
    getExistingTripDetails(){
      return new Promise((resolve, reject) => {
        let tripPayload = {
          "XBkey":"XB123",
          "HubId":this.hubname,
          "DeliveryUserId":this.deliverUserName.toString()
        }
        axios.post(apiUrl.api_url + 'expose/trip/tripDetails', tripPayload)
         .then((response) => {
           if(response.data.TripState == 'created') {
             this.$alertify.error('Trip not started for SR. Please start trip from SR app.');
             resolve(false);
           } else {
             resolve(true);
           }
         })
         .catch((httpException) => {
           this.$alertify.error("Not getting any response message");
           console.error('exception is:::::::::', httpException);
           resolve(false);
        })
      });
    },
    getHubList() {
      this.isLoading = true;
      axios
        .get(apiUrl.api_url + "shipmentMisrout/gethublist", {})
        .then(response => {
          if (response.data.code === 200) {
            this.hubServiceCenterList = response.data.data;
          } else {
            this.hubServiceCenterList = [];
          }
          this.isLoading = false;
        })
        .catch(httpException => {
          this.$alertify.error("hub data not found");
          console.error("exception is:::::::::", httpException);
        });
    },
    getdeliveryusername() {
      this.getDeliveryUname = [];
      this.deliveryList = [];
      this.deliverUserName = "";
      let HubIDArr = [];
      let HubData = {};
      this.DeliverySRList = [];
      HubIDArr.push(this.hubname);
      HubData.HubID = HubIDArr;
      this.srLoader = this.loader;

      if (this.rolename.toLowerCase()=="agent" || this.userRolesFE.includes("agent")){
       let Emppayload = {
         "OutSourcingId": this.localuseroutsourcingid,
         "hubid": HubData.HubID
       }
       //console.log('Emppayload',Emppayload);
        let apiendpoint = 'agenthandovershipments/getDeliveryUserName';
        if (keycloak.enableKavach) {
          apiendpoint = 'user/migration/getoutsourceuserlist';
        }
       axios.post(apiUrl.api_url + apiendpoint, {
           Emppayload
         })
         .then((response) => {
           //console.log('Response : ',response);
         if (response.data.code === 200) {
             this.DeliverySRList = response.data.data;
             $.each(response.data.data , (key,obj)=>{
               this.deliveryList.push({
                 value: `${obj.DeliveryUserId}`,
                 text: `${obj.FirstName} ${obj.LastName} (${obj.OldDeliveryUserOrUserId} - ${obj.DeliveryUserId}) - (${obj.MobileNumber})`
               })
             });
             if (!this.deliveryList.length){
                  this.$alertify.error("Delivery user not found");
             }
          }
           else {
             this.getDeliveryUname = [];
               // this.$alertify.error("Delivery user not found");
           }
           this.srLoader='';
         })
         .catch(httpException => {
           this.$alertify.error("User details not found");
           console.error("exception is:::::::::", httpException);
         });
     }else {
      let apiendpoint = 'external/getremoteuserdetails/byhubid';
      if (keycloak.enableKavach) {
        apiendpoint = 'user/migration/getuserdetailsbyhubids';
      }
      axios
        .post(apiUrl.api_url + apiendpoint, HubData)
        .then(async response => {
          if (response.data.code === 200) {
            this.DeliverySRList = response.data.data.results;
            await response.data.data.results.map(userdata=>{
              if (userdata.username != null){
                  //this.getDeliveryUname.push(userdata);
                  this.deliveryList.push({value:userdata.userid, text: `${userdata.FirstName} ${userdata.LastName} (${userdata.OldDeliveryUserOrUserId}) (${userdata.userid})`})
              }
            })
         } else {
            this.getDeliveryUname = [];
          }
          this.srLoader='';
        })
        .catch(httpException => {
          this.$alertify.error("User details not found");
          console.error("exception is:::::::::", httpException);
        });
      }
    },

   StatusCodeList() {
    
  if(!this.lmwhhandoverallowed){
    if(this.shipmenttype == "DTO"){
      this.ReasonStatusArr = [{
        "uniquecode":"XBU00383",
        "userprocess":"DTO Undelivered"
      }]
      this.DisputeStatusArr = [{
        "uniquecode":"XBU00957",
        "userprocess":"Shipment snatched"
      }]
    }else {
      this.ReasonStatusArr = [{
        "uniquecode":"XBU00382",
        "userprocess":"RTO Undelivered"
      }]
      this.DisputeStatusArr = [{
        "uniquecode":"XBU00956",
        "userprocess":"Shipment snatched"
      }]
    }
  }else{
    let checkprocesscode= {};
    let postdata = {};
    postdata.ShipmentType = this.shipmenttype;

    this.isLoading = true;
     axios
      .post(
        apiUrl.api_url +
          `external/getStatusDetails/for/RTODTO`,
        postdata
      )
      .then(response => {

       if (response.data.code === 200) {
          this.ReasonStatusArr = response.data.data.Status;
          this.DisputeStatusArr = response.data.data.DisputeStatus;
        } else {
          this.ReasonStatusArr = [];
          this.DisputeStatusArr =[];
        }
        this.isLoading = false;
      })
      .catch(httpException => {
        this.$alertify.error("User details not found");
        console.error("exception is:::::::::", httpException);
      });
    }},

    changeDisputeCode(){  
      if(["XBU00643","XBU00662","XBU00305","XBU00333"].includes(this.disputeCode)){
        this.reattemptDeliveryDateShow = true;
      }else{
        this.reattemptDeliveryDateShow = false;
      }
      this.subDisputeCode = "";
      let subDisputeStatusCode = this.disputeCode;
      let SubReasonObject = this.DisputeStatusArr.filter((statusCode)=>{
        return statusCode.uniquecode == subDisputeStatusCode;
      })
      console.log('SubReasonObject.length',SubReasonObject.length);
      if(SubReasonObject.length > 0){
        if(SubReasonObject[0].hasSubStatus != undefined && SubReasonObject[0].hasSubStatus == true) {
          let key_generate = `${subDisputeStatusCode}_deliverySubstatus`;
          this.subDisputeStatusReasonCodes = SubReasonObject[0][key_generate];
          console.log('Sub-statusCodedisputeListObj',this.subDisputeStatusReasonCodes);
          this.subDisputeCodeFlag = true;
        } else {
          this.subDisputeStatusReasonCodes = [];
          this.subDisputeCode = "";
          this.subDisputeCodeFlag = false;
        }
      }
    },

    async ShowShipmentDetails(checknumber) {

    this.dateobj.toDate= new Date().toISOString().slice(0,10);
    // this.time = this.secondsToHms(new Date());
    this.clearFormData() // clear existing form fields.

      this.awbArray=[];
      if (!this.shipmenttype) {
        return this.$alertify.error("Please select shipment type");
      } else if (!this.hubname) {
        return this.$alertify.error("Please select hub name");
      } else if (!this.deliverUserName) {
        return this.$alertify.error("Please select deliver username");
      }else if (this.awb) {
        var shippingids = $("#awb").val();
        let shippingidNext=shippingids.split(/[\n]+/);
        let shippingidComma=shippingids.split(/[,]+/);
        if(shippingidNext.length > 10 || shippingidComma.length > 10){
          return this.$alertify.error("ShippingIDs not allow more than 10");
        }else {
          let shippingidsWithNextLine = this.awb.split("\n").map(String);
          let shippingidsWithComma = this.awb.split(",").map(String);
          if(shippingidsWithNextLine.length > 1) {
            console.log('nextLineExecuted');
            this.awbArray = shippingidsWithNextLine.filter(function (sid) {
               return sid != null && sid !='';
            });
          } else if(shippingidsWithComma.length >= 1){
            console.log('CommaExecuted');
            this.awbArray = shippingidsWithComma.filter(function (sid) {
               return sid != null && sid !='';
            });
          }
        }
      }else if (!this.awb && checknumber == 1) {
        return this.$alertify.error("ShppingIDs should be mandatory.");
      }
      this.disabledcount= 1;
      let totalCount=null;
      this.isLoading = true;
      this.selectedItems = [];
      let shipmentdata = {};
      shipmentdata.ShipmentType = this.shipmenttype;
      shipmentdata.HubId = this.hubname;
      shipmentdata.DeliveryUserID = this.deliverUserName;
      shipmentdata.pageNo = this.pageno !== 0 ? this.pageno : 1;
      shipmentdata.perPage = 75;

      if (this.awbArray.length > 0){
        shipmentdata.awbArray = this.awbArray;
        shipmentdata.perPage = shipmentdata.awbArray.length;
        shipmentdata.pageNo = 1;
      }

      await axios
        .post(
          apiUrl.api_url + `expose/web/get/shipmentdataformarkedwhhandover`,
          shipmentdata
        )
        .then(response => {
            if (response.data.code === 200 && response.data.data.data.length > 0) {
            this.LatmileShipmentData = response.data.data.data;
            this.LastStoreddata = this.LatmileShipmentData;
            this.checkCount = 1;
            this.StatusCodeList();
            this.tblErrorshowflag =null
           let totalRows = response.data.data.total;
           this.totalCountpagi = totalRows;

           if (totalRows < 75) {
              this.pagecount = 1;
            } else {
              this.pagecount = Math.ceil(totalRows / 75)
            }
            this.disabledcount = null;
            this.isLoading = false;
              try {
                let TrackerInfo = {
                  projectname: "Last Mile",
                  type: "Web",
                  routeurl: "expose/web/get/shipmentdataformarkedwhhandover",
                  userid: this.localuserid,
                  username: this.localusermailid,
                  meta: {
                    event: "get-shipmentdataformarkedwhhandover",
                    shipmentId: this.shippingIdForMeta ? this.shippingIdForMeta : null,
                    remarks: "FrontEnd",
                    hubId : this.hubname ? this.hubname : null
                  },
                };
                Object.assign(TrackerInfo.meta, shipmentdata);
                this.PageTracker(TrackerInfo);
              } catch (error) {
                console.log(error);
              }
          } else {
            if (this.awb && checknumber == 1) {
                this.checkCount = 1;
                this.tblErrorshowflag =1;
                  this.isLoading = false;
                return false;
            }
            this.checkCount = null;
            this.isLoading = false;
            this.disabledcount = null;
            return this.$alertify.error(response.data.message);
          }
          this.isLoading = false;

        })
        .catch(httpException => {
          this.$alertify.error("Data Not Found");
          console.error("exception is:::::::::", httpException);
        });
      // let totalRows = this.LatmileShipmentData.length;
      // console.log("totalRows",totalRows);
      // if (totalRows < 10) {
      //     this.pagecount = 1;
      // } else {
      //    this.pagecount = Math.ceil(totalRows / 10)
      // }
    },

    selectItems(ev) {
      this.selectedItems = [];
      if (ev.target.checked == true) {
        for (let i in this.LatmileShipmentData) {
          // adding logic for select all maximum 20
          if ( i <  75){
            this.selectedItems.push(
              this.LatmileShipmentData[i].ShippingID.toString()
            );
          }
        }
      }
    },

    setcheckbox(event) {
      if (event.target.checked == false) {
        this.selectedItemdata = false;
      }
  },

    clear() {
      this.errormsg = [];
      this.dateobj.toDate = "";
      this.receiverName = "";
      this.time = "";
      this.statusCode = "";
      this.$validator.reset();
      this.errors.clear();
      this.selectedItemdata = false;
      this.successArr = [];
      this.failedArr = [];
      this.viewShipmentData = [];
      this.whdisputeCode ="";
      this.disputeCode="";
      this.disputevalidator =null;
      this.whdisputeCodevalue =null;
      this.awbArray=[];
      this.awb='';
      this.ProcessShipment=[];
      this.tblErrorshowflag=null;
      this.reattemptDeliveryDateShow=false;
      this.ShowShipmentDetails(null);
    },

    async getshipmentviewdata(ShippingID) {
      this.storeShippingid = null;
      this.viewShipmentData = [];
      this.shipmentviewdataflag = true;
      this.storeShippingid = ShippingID;

      if (this.successArr.length) {
        this.successArr.forEach(testdata => {
          if (testdata.ShippingID == ShippingID) {
            this.viewShipmentData.push(testdata);
          }
        });
      }
      if (this.failedArr.length) {
        this.failedArr.forEach(testdata => {
          if (testdata.ShippingID == ShippingID) {
            this.viewShipmentData.push(testdata);
          }
        });
      }
    },

    closeonPopup() {
      this.shipmentviewdataflag = false;
      this.errormsg = [];
      this.$validator.reset();
      this.errors.clear();
    },

showdisputereason(event){

if(this.statusCode == "XBU00161"){
  this.reciverflage = 1;
}else {
  this.receiverName='';
  this.reciverflage = null;
}
this.subDisputeStatusReasonCodes = [];
this.subDisputeCodeFlag = false;
this.disputeCode = "";
let localvalue = null;
let  whlocalvalue =null;

let  dtovalue =null;

if (this.ReasonStatusArr.length > 0){
this.ReasonStatusArr.map(Status=>{
  // for RTO

  if (event.target.value ==  Status.uniquecode && Status.userprocess == "RTO Undelivered"){
     localvalue =1;
     this.reasonstatus ="RTOPODRemark"
  }
  else if (event.target.value ==  Status.uniquecode && Status.userprocess == "WHHandover"){
    whlocalvalue =1;
    this.reasonstatus ="RTOPODRemark";
  }

  // for DTO
  if (event.target.value ==  Status.uniquecode && Status.userprocess == "DTO Undelivered"){
   localvalue =1;
   this.reasonstatus ="DTOPODRemark";
  }else if (event.target.value ==  Status.uniquecode && Status.userprocess == "Shipment WHHandover") {
   whlocalvalue =1;
   this.reasonstatus ="DTOPODRemark";
 }
});


 if (localvalue == 1){
    this.disputevalidator =1;
    this.getReasonbyreasonType();
 }else{
   localvalue = null;
   this.disputevalidator =null;
 }

 if (whlocalvalue == 1){
    this.whdisputeCodevalue =1;
    this.getReasonbyreasonType();
 }else{
   whlocalvalue=null;
   this.whdisputeCodevalue =null;
 }

}
},


getReasonbyreasonType(){
axios.get(
  apiUrl.api_url + "external/getreasons" + "?" + "reasonType" + "=" + this.reasonstatus)
     .then(response => {
    if (response.data.code === 200) {
       this.reasontypedata = response.data.data;
     } else {
       this.reasontypedata = [];
     }
     this.isLoading = false;
   })
   .catch(httpException => {
     this.$alertify.error("Reasons not found");
     console.error("exception is:::::::::", httpException);
   });

},

getPaginationData(pageNum) {
  console.log("Printing page Number", pageNum);
  this.pageno = pageNum;
  this.ShowShipmentDetails();
},

clearAll2(){
  this.awb=''
  this.awbArray=[];
  this.ShowShipmentDetails();
},
getdeliveyList(obj){
  this.deliveryObj = obj
  this.deliverUserName = this.deliveryObj.value
  this.resetFormFields('srSelection')
},
clearFormData() {
  this.time = ''
  this.statusCode = ''
  this.receiverName = ''
  this.disputeCode = ''
  this.DisputeStatusArr = []
  this.ReasonStatusArr = []
  this.whdisputeCode = ''
  this.$validator.reset();
  this.errors.clear();
  this.reattemptDeliveryDateShowf=false;
},
resetFormFields(soureOfEvent){
  if(!this.setWebHDFlag) {
    this.$alertify.error('Web based status updation is disabled, pls use Mobile App for status updation.')
    this.$router.push('/dashboard')
    return false;
  }

  if(soureOfEvent == 'shipmentTypeSelection') {
    this.deliverUserName = ''
    this.deliveryObj = { value: "",text: ""}
  }
  this.time = ''
  this.statusCode = ''
  this.receiverName = ''
  this.disputeCode = ''
  this.whdisputeCode = ''
  this.reciverflage = null
  this.checkCount = null
  this.totalCountpagi = 0
  this.LatmileShipmentData = []
  this.$validator.reset()
  this.errors.clear()
  this.reattemptDeliveryDateShow=false;
}
//  toTimeString(d) {
//     var time = d.toTimeString()
//     return time;
// },
//
//  secondsToHms(d) {
//     var hours = d.getHours().toString().padStart(2, '0')
//     var minutes = d.getMinutes().toString().padStart(2, '0')
//     var seconds = d.getSeconds().toString().padStart(2, '0')
//
//     return `${hours}:${minutes}:${seconds}`
// }
}
};



// WEBPACK FOOTER //
// ./src/views/components/RTODeliveryStatus/RTODeliveryStatus.component.js